/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.fintech.discounts.rpc.PromotionsRpc
 */

export const PercentDiscountTypename = 'com.hubspot.fintech.discounts.models.self.service.PercentDiscount';
export const getPromotionsRpc = {
  serviceName: 'com.hubspot.fintech.discounts.rpc.PromotionsRpc',
  rpcName: 'getPromotions',
  auth: 'app',
  fingerprint: 'A7YjqMcXCdPO5nMoZSzIvEXdB4QtAr2h',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPromotionRpc = {
  serviceName: 'com.hubspot.fintech.discounts.rpc.PromotionsRpc',
  rpcName: 'getPromotion',
  auth: 'app',
  fingerprint: 'TAO-Gs-m1u1pT7UVkdz0q0XdB4QtAr2h',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllowedPortalsByPromotionIdRpc = {
  serviceName: 'com.hubspot.fintech.discounts.rpc.PromotionsRpc',
  rpcName: 'getAllowedPortalsByPromotionId',
  auth: 'app',
  fingerprint: 'l8yjjhzSNNKrQlQ2LJJv-kxxMJ3k-I7t',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEnrolledPromotionsByPortalIdRpc = {
  serviceName: 'com.hubspot.fintech.discounts.rpc.PromotionsRpc',
  rpcName: 'getEnrolledPromotionsByPortalId',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA7DrFM4EinG0xxMJ3k-I7t',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const enrollPortalRpc = {
  serviceName: 'com.hubspot.fintech.discounts.rpc.PromotionsRpc',
  rpcName: 'enrollPortal',
  auth: 'app',
  fingerprint: 'kDy34H8e9fdQToJxBlwHXHf642x2d6yP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const bulkEnrollPortalRpc = {
  serviceName: 'com.hubspot.fintech.discounts.rpc.PromotionsRpc',
  rpcName: 'bulkEnrollPortal',
  auth: 'app',
  fingerprint: 'wELJHLAnnaUzrP_8283sxXf642x2d6yP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};